<template>
  <div class="projects container-fluid">
    <div class="col-10 text">
      <h2>
        NATURA, STYL I CHARAKTER TO CECHY NA KTÓRYM POWSTAŁA KOLEKCJA „STARYCH
        DĘBÓW”. RUSTYKALNY STYL TYCH DESEK SPRAWIA, ŻE KAŻDE WNĘTRZE NABIERA
        MOCY I CHARAKTERU.
      </h2>
      <p>
        Z przyjemnością prezentujemy Państwu naszą najnowszą kolekcję, w której
        znajdą Państwo podłogi dekoracyjne, będące doskonałym dopełnieniem
        każdego stylowego wnętrza. Przy projektowaniu produktów z tej linii
        inspirowaliśmy się naturą i naturalnie zachodzącymi w przyrodzie
        procesami. Tak powstała kolekcja o niespotykanej kolorystyce z ręcznie
        frezowaną krawędzią deski, dającą dodatkowy, która podkreśla ich
        rustykalny charakter. Kolekcja wzorów ręcznie malowanych, które maluje
        sama natura. Wszystkie deski z tej kolekcji malowane są specjalnymi
        środkami, które łączą się z garbnikami zawartymi w drewnie dębowym, co
        pozwala na uzyskanie nieprawdopodobnych efektów i wzorów. Na kolor desek
        nie tylko ma wpływ kolor oleju, ale również w jakieś części świata rosło
        drzewo, jak wzrastało oraz w jakim jest wieku. Nie powtarzalne wzory
        tworzy tutaj natura.
      </p>
    </div>
    <div
      v-scrollanimation
      class="image col-10 col-sm-5 col-md-4 col-xl-3"
      v-for="(image, index) in media"
      :key="index"
      @click="openGallery(index)"
      :style="{
        width: 'auto',
        height: '17rem'
      }"
    >
      <img v-lazy="image.src || image.thumb" @click="openGallery(index)" />
      <h3>{{ image.caption }}</h3>
    </div>

    <LightBox
      ref="lightbox"
      :media="media"
      :show-caption="true"
      :show-light-box="false"
    />
  </div>
</template>

<script>
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import Images from "./oldOak.js";
import LightBox from "vue-image-lightbox";
export default {
  data: function() {
    return {
      index: null,
      media: Images
    };
  },
  methods: {
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    }
  },

  components: {
    LightBox
  }
};
</script>
<style scoped>
.text {
  text-align: center;
  margin-top: 2%;
}
.projects {
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.image {
  height: auto;
  display: inline-block;
  position: relative;
  transition: 0.3s;
  margin: 1%;
}

.image img {
  width: 100%;
  height: 100%;
  transition: 0.3s;
  border-radius: 4px;
}

.image:hover img {
  filter: blur(2px) brightness(60%);
  box-shadow: 0 0 16px rgb(32, 28, 28);
  cursor: pointer;
}

.image :not(img) {
  position: absolute;
  z-index: 1;
  width: 90%;
  top: 50%;

  left: 5%;
  color: #fff;
  opacity: 0;
  transition: 0.3s;
}

.image:hover :not(img) {
  cursor: pointer;
  opacity: 1;
}
</style>
